import React from 'react';
import { Smartphone, Building2 } from 'lucide-react';

/**
 * Landing'deki eski "Pricing" bölümünün yerine (doküman 48 §11 K4).
 *
 * Neden fiyat yok: yıllık üyelik yalnız uygulama içinden (App Store / Google Play)
 * satılıyor. Web'de "100 TL/yıl" yazıp uygulamada aynı fiyatla satmak bile Apple
 * 3.1.3(b)/anti-steering okumasına zemin oldu (1.0.7 reddi); web'den satış kapandığı
 * için kart ve fiyat da kalktı. Kurumsal yalnız teklif formu — panel girişi menüden çekildi (K3).
 */
export default function MembershipCta({ L, setCheckoutPackage, setShowCheckout, setCheckoutUrl, setErrorMsg, setCorporateSuccess, setShowDownloadModal }: any) {
  const openCorporate = () => {
    setCheckoutPackage('KURUMSAL');
    setCheckoutUrl(null);
    setErrorMsg(null);
    setCorporateSuccess(false);
    setShowCheckout(true);
  };

  return (
    <section id="membership" className="py-16 md:py-24 relative">
      <div className="divider-glow mb-16 mx-12" />
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <div className="reveal inline-block glass-panel px-4 py-2 rounded-full text-xs text-[#FFB020] uppercase tracking-widest font-semibold mb-6">
            {L.membership.badge}
          </div>
          <h2 className="reveal reveal-delay-1 text-4xl md:text-5xl font-black text-white mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
            {L.membership.title}
          </h2>
          <p className="reveal reveal-delay-2 text-gray-400 text-lg">
            {L.membership.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          <div className="reveal glass-panel rounded-3xl p-8 md:p-9 flex flex-col justify-between" style={{ border: '1px solid rgba(255, 176, 32,0.30)', boxShadow: '0 8px 40px rgba(255, 176, 32,0.10)' }}>
            <div>
              <div className="w-12 h-12 rounded-2xl bg-[#FFB020]/10 border border-[#FFB020]/30 flex items-center justify-center text-[#FFB020] mb-5">
                <Smartphone size={22} />
              </div>
              <h3 className="text-2xl font-bold text-white mb-3" style={{ fontFamily: 'var(--font-heading)' }}>{L.membership.individualTitle}</h3>
              <p className="text-gray-400 text-sm leading-relaxed">{L.membership.individualDesc}</p>
            </div>
            <button
              type="button"
              onClick={() => setShowDownloadModal(true)}
              className="mt-8 btn-signal font-bold px-6 py-3.5 rounded-2xl text-sm inline-flex items-center justify-center gap-2"
            >
              <Smartphone size={16} /> {L.membership.download}
            </button>
          </div>

          <div className="reveal reveal-delay-1 glass-panel rounded-3xl p-8 md:p-9 flex flex-col justify-between" style={{ border: '1px solid rgba(255,255,255,0.08)' }}>
            <div>
              <div className="w-12 h-12 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center text-gray-200 mb-5">
                <Building2 size={22} />
              </div>
              <h3 className="text-2xl font-bold text-white mb-3" style={{ fontFamily: 'var(--font-heading)' }}>{L.membership.corporateTitle}</h3>
              <p className="text-gray-400 text-sm leading-relaxed">{L.membership.corporateDesc}</p>
            </div>
            <button
              type="button"
              onClick={openCorporate}
              className="mt-8 font-bold px-6 py-3.5 rounded-2xl text-sm inline-flex items-center justify-center gap-2 text-white bg-white/5 border border-white/10 hover:bg-white/10 hover:border-[#FFB020]/30 transition-colors"
            >
              <Building2 size={16} /> {L.membership.corporateCta}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
